define('plugin/product/view/ProductIndexHeaderView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#product_index_header_view',

        ui: {
            sort: '#sort'
        },

        events: {
            'change @ui.sort': 'onSortChange'
        },

        initialize: function () {
            LayoutView.prototype.initialize.call(this);

            this._categoryCollection = this.getOption('categoryCollection');
            if (this._categoryCollection) {
                this.listenTo(this._categoryCollection, 'sync', this.safeRender);
            }
            this.listenTo(this.getOption('collection'), 'sync', this.safeRender);
        },

        serializeData: function () {
            var category = this._categoryCollection ? this._categoryCollection.findWhere({id: this.getOption('category')}) : null;

            return _.extend(LayoutView.prototype.serializeData.call(this), {
                category: category ? category.toJSON() : null,
                sort_values: this.getSortValues(),
                sort: this.getOption('collection').length && this.getOption('sort')
            });
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        getSortValues: function () {
            return [
                {id: 'natural', name: Locale.get('sort_natural')},
                {id: 'name', name: Locale.get('sort_name')},
                {id: 'price-asc', name: Locale.get('sort_price_asc')},
                {id: 'price-desc', name: Locale.get('sort_price_desc')},
            ]
        },

        onSortChange: function () {
            this.triggerMethod('sort', this.ui.sort.val());
        }

    });

});
